import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { UnsubscribeComponent } from "../../../../generals/Components";
import { ApiService } from "../../../../services/api.service";
import { AdminModuleDetail, LabelValue, LabelValueNumber, ModuleGoogleMerchantFeedConfig, ModuleGoogleMerchantFeedConfigCatalog, ModuleGoogleMerchantFeedConfigCatalogType, ProductPriceType } from "../../../../interfaces/interfaces";
import { filter, takeUntil } from "rxjs/operators";
import { DialogService } from "primeng/dynamicdialog";
import { ConfirmComponent } from "../../../confirm/confirm.component";
import { CategorySelectorModalComponent } from "../../../categoryselectormodal/categoryselectormodal.component";

@Component({
	selector: 'app-googlemerchantmodule',
	templateUrl: './googlemerchantmodule.component.html'
})
export class GoogleMerchantModuleComponent extends UnsubscribeComponent implements OnInit, OnChanges {

	ModuleGoogleMerchantFeedConfigCatalogType = ModuleGoogleMerchantFeedConfigCatalogType;

    @Input() module: AdminModuleDetail<ModuleGoogleMerchantFeedConfig> = null;

    @Output() inited: EventEmitter<boolean> = new EventEmitter();
    @Output() configChanged: EventEmitter<boolean> = new EventEmitter();
    @Output() reload: EventEmitter<boolean> = new EventEmitter();

    catalogTypes: LabelValue[] = [
        { label: 'Kategóriák', value: ModuleGoogleMerchantFeedConfigCatalogType.CATEGORIES },
        { label: 'Terméklista', value: ModuleGoogleMerchantFeedConfigCatalogType.PRODUCTLIST }
    ];

	catalogs: ModuleGoogleMerchantFeedConfigCatalog[] = [];

	priceTypes: LabelValueNumber[] = [];

    constructor(
        private apiService: ApiService,
		private dialogService: DialogService
    ) {
        super();
    }

    ngOnInit(): void {
        this.inited.emit(true);
        this.init();
    }

    init(): void {
		this.initCatalogs();
		this.loadData();
    }

	initCatalogs(): void {
		const catalogs: ModuleGoogleMerchantFeedConfigCatalog[] = this.module.config.catalogs || [];
		catalogs.forEach((catalog: ModuleGoogleMerchantFeedConfigCatalog) => {
			catalog.blacklistString = catalog.blacklist.join('\r\n');
			catalog.productCodesString = catalog.productCodes.join('\r\n');
		})
		this.catalogs = catalogs;
	}

	loadData(): void {
		this.apiService.getSimpleTable<ProductPriceType>('productpricetypes').subscribe(({data}) => {
			this.priceTypes = data.map((priceType: ProductPriceType) => ({
				label: priceType.name,
				value: priceType.id
			}));
		});
	}

	catalogChanged(): void {
		this.configChanged.emit(true);
	}

	selectCategory(catalog: ModuleGoogleMerchantFeedConfigCatalog): void {
		this.dialogService.open(CategorySelectorModalComponent, {
			data: {
				selectedIds: catalog.categoryIds
			}
		}).onClose.pipe(filter(res => res !== undefined)).subscribe((categoryIds: number[]) => {
			catalog.categoryIds = categoryIds;
			this.configChanged.emit(true);
		});
	}

	createCatalog(): void {
		this.catalogs.push({
			guid: null,
			name: '',
			type: ModuleGoogleMerchantFeedConfigCatalogType.CATEGORIES,
			categoryIds: [],
			productCodes: [],
			blacklist: [],
			blacklistString: '',
			productCodesString: '',
			url: null,
			priceId: this.priceTypes[0].value
		});
		this.configChanged.emit(true);
	}

	deleteCatalog(index: number): void {
		this.dialogService.open(ConfirmComponent, {
		  data: {
			title: 'Katalógus törlése',
			text: 'Biztosan törölni szeretnéd ezt a katalógust?',
			acceptText: 'Törlés',
			declineText: 'Mégse'
		  }
		}).onClose.pipe(filter(r => r === true)).subscribe(() => {
			this.catalogs.splice(index, 1);
			this.configChanged.emit(true);
		});
	}

	saveConfig(): void {
		const catalogs: ModuleGoogleMerchantFeedConfigCatalog[] = JSON.parse(JSON.stringify(this.catalogs));
		catalogs.forEach((catalog: ModuleGoogleMerchantFeedConfigCatalog) => {
			catalog.blacklist = catalog.blacklistString.split('\n');
			catalog.productCodes = catalog.productCodesString.split('\n');
			delete catalog.blacklistString;
			delete catalog.productCodesString;
		});
		const config: ModuleGoogleMerchantFeedConfig = {
			catalogs
		}
		this.apiService.saveModuleConfig(this.module.id, config).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
			this.configChanged.emit(false);
			this.reload.emit(true);
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.module !== undefined) {
			this.initCatalogs();
		}
	}
}